/* eslint-disable no-param-reassign */

const ensureEntities = (state) => {
  if (!state.entities) {
    state.entities = {
      listings: {},
      listingVariants: {},
      listingVariantIndex: {},
      assets: {
        listingAssets: {},
        listingVariantAssets: {},
        masterAssets: {},
        masterVariantAssets: {},
      },
    };
  }

  if (!state.entities.listingVariantIndex) {
    state.entities.listingVariantIndex = {};
  }
};

const ensureAssets = (state) => {
  ensureEntities(state);

  if (!state.entities.assets) {
    state.entities.assets = {
      listingAssets: {},
      listingVariantAssets: {},
      masterAssets: {},
      masterVariantAssets: {},
    };
  }
};

export const upsertListing = (state, listing) => {
  if (!listing?._id) return;

  ensureEntities(state);
  state.entities.listings[listing._id] = listing;
};

export const removeListing = (state, listingProductId) => {
  if (!listingProductId || !state.entities?.listings) return;

  delete state.entities.listings[listingProductId];
};

export const upsertListingVariant = (state, listingVariant) => {
  if (!listingVariant?._id) return;

  ensureEntities(state);
  state.entities.listingVariants[listingVariant._id] = listingVariant;
};

export const removeListingVariant = (state, listingVariantId) => {
  if (!listingVariantId || !state.entities?.listingVariants) return;

  delete state.entities.listingVariants[listingVariantId];
};

export const replaceListingVariantIndexForMaster = (state, masterProductId, rows = []) => {
  if (!masterProductId) return;

  ensureEntities(state);

  Object.values(state.entities.listingVariantIndex).forEach((row) => {
    if (String(row.masterProductId) !== String(masterProductId)) return;
    delete state.entities.listingVariantIndex[row._id];
  });

  rows.forEach((row) => {
    if (!row?._id) return;
    state.entities.listingVariantIndex[row._id] = {
      ...row,
      masterProductId,
    };
  });
};

export const syncListingVariantsFromIndex = (state, rows = []) => {
  if (!state.entities?.listingVariants) return;

  rows.forEach((row) => {
    const listingVariantId = row.listingVariantId || row._id;
    if (!listingVariantId) return;
    const existing = state.entities.listingVariants[listingVariantId];
    if (!existing) return;

    existing.listingStatus = row.listingStatus ?? existing.listingStatus;
    if (row.live) {
      existing.live = existing.live ? { ...existing.live, ...row.live } : row.live;
    } else {
      delete existing.live;
    }
  });
};

export const removeListingVariantIndex = (state, listingVariantId) => {
  if (!listingVariantId || !state.entities?.listingVariantIndex) return;

  delete state.entities.listingVariantIndex[listingVariantId];
};

export const setListingAssets = (state, listingProductId, assets) => {
  if (!listingProductId) return;

  ensureAssets(state);
  state.entities.assets.listingAssets[listingProductId] = assets;
};

export const setListingVariantAssets = (state, listingVariantId, assets) => {
  if (!listingVariantId) return;

  ensureAssets(state);
  state.entities.assets.listingVariantAssets[listingVariantId] = assets;
};

export const setMasterAssets = (state, masterProductId, assets) => {
  if (!masterProductId) return;

  ensureAssets(state);
  state.entities.assets.masterAssets[masterProductId] = assets;
};

export const setMasterVariantAssets = (state, masterVariantId, assets) => {
  if (!masterVariantId) return;

  ensureAssets(state);
  state.entities.assets.masterVariantAssets[masterVariantId] = assets;
};
